export default __webpack_public_path__ + "static/media/menu-assinaturas.02e56b8d.svg";